__turbopack_context__.v({
  "background": "NewsPageHero-module-scss-module__S47Y_G__background",
  "backgroundImage": "NewsPageHero-module-scss-module__S47Y_G__backgroundImage",
  "content": "NewsPageHero-module-scss-module__S47Y_G__content",
  "hero": "NewsPageHero-module-scss-module__S47Y_G__hero",
  "topSlot": "NewsPageHero-module-scss-module__S47Y_G__topSlot",
});
